<template>
  <div v-loading="loading" class="main_center">
    <iframe
        ref="mainIframe"
        :src="`${$bigDataUrl}/#/iframeLogin?token=${mainToken}&hideHeaderNav=${true}&isIframe=${isIframe}&url=${url}&isFilterDept=${isFilterDept}`"
        width="100%"
        :style="{'height': documentClientHeight-115 + 'px'}"
        frameborder="0"
        scrolling="yes"
        id="mainIframeId"
        name="mainIframeName"
        @load="setIFrameHeight"
    >
    </iframe>
  </div>
</template>

<script>
  import loginHttp from "@/utils/login";
export default {
  name: "index",
  data() {
    return {
      loading: true,
      isFilterDept:false,
      mainToken:'', // token
      isIframe:true, // 标识
      url:'warning-projectindex', // 要跳转的指定路由位置(传name即可)
  }
  },
  computed: {
    // 获取高度，解决iframe高度固定150的问题
    documentClientHeight: {
      get () { return this.$store.state.common.documentClientHeight },
      set (val) { this.$store.commit('common/updateDocumentClientHeight', val) }
    },
  },
  created() {
    this.mainToken = this.$cookie.get('access_token');
    //通过请求接口 /userinfo 返回数据里的 roleCodes 判断是否传参,
    this.getInfo()
  },
  mounted() {
    const iframe = this.$refs.mainIframe;
    // IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
    if (iframe.attachEvent) { // IE
      iframe.attachEvent('onload', () => { this.loading = false; });
    } else { // 非IE
      // iframe.onload =  () => { this.loading = false; };
      iframe.onload =  () => { this.loading = false; 
       var a= window.frames["mainIframeName"].document.getElementById("isIframeB")
        var b=document.getElementById("mainIframeId").contentWindow.document.getElementById("isIframeB")
       
      };
    }
  },
  methods:{
    getInfo(){
      loginHttp.get("/userinfo").then(res => {
          if (res.data.code === "1") {
            let roleCodes = res.data.data.roleCodes||this.$store.state.user.userinfo.roleCodes || [];
            // 是否是行业监管部门工作人员，若是，则传参通知大数据页面过滤监管部门数据
            this.isFilterDept = roleCodes.indexOf('SUPERVISION_WORKER') > -1?true:false;
          }
        });
    },
    setIFrameHeight(){
      setTimeout(()=>{
        var c= window.frames["mainIframeName"].document.getElementById("isIframeB")
        var d=document.getElementById("mainIframeId").contentWindow.document.getElementById("isIframeB")
      },1000)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
